export default __webpack_public_path__ + "static/media/Headset.88594f10.jpg";